// Dependencias generales
import React from "react";
import { useEffect, useState } from 'react';
import ReactGA from "react-ga4";
import imgNoResultsDark from '../../img/dark-theme/empty-state.svg'
import InstallationActivityDay from '../../components/InstallationActivity/InstallationActivityDay'
import ActivitySearchForm from "../../components/InstallationActivity/ActivitySearchForm";

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const postListInstallationActivity = endpointHelias+'/Helias/V0/General/postListInstallationActivity';	

var initialConfigCommonJS = require("../../js/initialConfigCommon.js")
var dashboardCommonJS = require("../../js/dashboardCommon.js")
var generalCommonJS = require("../../js/generalCommon.js")

var primeraCargaRealizada = false

const InstallationActivity = (params) => {  

  const [objListadoActividad, setObjListadoActividad] = useState([])  
  
  useEffect(() => {     
    console.log("Página de actividad de la instalación cargada correctamente.")
    
    if((objListadoActividad.length === 0) && (primeraCargaRealizada === false)){
      cargarDatosActividadInstalacion()           
      abrirFormularioFechas()
    }else{
      filtrarDatos()
    }
    
  }, [objListadoActividad])

  function cargarDatosActividadInstalacion(){ 

    var tsFechaDesde = new Date(document.getElementById("fechaDesde").value+"T"+document.getElementById("horaDesde").value).getTime()
    var tsFechaHasta = new Date(document.getElementById("fechaHasta").value+"T"+document.getElementById("horaHasta").value).getTime()

    if(tsFechaDesde <= tsFechaHasta){

      document.getElementById("fechaActividad").className = document.getElementById("fechaActividad").className.replaceAll("hidden","") + " hidden"
        
      var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
      var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        

      document.getElementById("loaderActividad").className = document.getElementById("loaderActividad").className.replace(" hidden", "") 

      //Petición de datos para el paso actual
      var jsonPeticion = {
        "accountID": localStorage.getItem("accountID"),
        "installationID": localStorage.getItem("installationId"),
        "datetimeFrom": document.getElementById("fechaDesde").value+"T"+document.getElementById("horaDesde").value+":00",
        "datetimeTo": document.getElementById("fechaHasta").value+"T"+document.getElementById("horaHasta").value+":59",
        "filters": "activityCategory-actionId-actionStatusId-deviceId-deviceName-actionValue"
      }
      
      // Guardo la información  
      var xhttp = new XMLHttpRequest();  
        xhttp.open("POST", postListInstallationActivity, true);        
        xhttp.setRequestHeader('Content-Type', "application/json");
        xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
        var data = JSON.stringify(jsonPeticion);
        xhttp.onreadystatechange = function() {
          if (this.readyState === 4 && this.status === 200) {
            var jsonRespuesta = JSON.parse(this.responseText.replaceAll("\\", "\\\\"))
    
            if(jsonRespuesta.statusCode === "403"){                   
              initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
            }
            else{          
              //Si recibo datos ya configurados lo cargo  

              if(typeof jsonRespuesta.body !== 'undefined'){
                
                setObjListadoActividad(jsonRespuesta.body)

                document.getElementById("loaderActividad").className += " hidden"

                if(document.getElementById("formularioBusqueda") !== null){
                  document.getElementById("formularioBusqueda").removeAttribute("open")
                }  

                generalCommonJS.registrarEventoAnalitica(ReactGA, 'ACTIVIDAD', 'BÚSQUEDA', document.getElementById("fechaDesde").value+" - "+document.getElementById("fechaHasta").value, "")
                
                primeraCargaRealizada = true

                if(jsonRespuesta.body.length > 0){
                  document.getElementById("fieldsetTextoBuscadorActividad").className = document.getElementById("fieldsetTextoBuscadorActividad").className.replaceAll("hidden","")
                }
                else{
                  document.getElementById("fieldsetTextoBuscadorActividad").className = document.getElementById("fieldsetTextoBuscadorActividad").className.replaceAll("hidden","") + " hidden"
                }

              }  

              //Si no hay datos configurados entonces no hago nada  
              console.log("Datos de la actividad de la instalación cargados correctamente.")
            }
          }
    
          if (this.readyState === 4 && this.status !== 200) {      
            initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
          }
        }
        xhttp.send(data);    
    }
    else{
      initialConfigCommonJS.mostrarMensajeInformativo("La fecha y hora 'Desde' no puede ser posterior a la fecha y hora 'Hasta'","negative")
    }
      
  }

  function gestionarVisibilidadFechasActividad(event){        
    if ( (document.getElementById("fechaActividad") !== null) && !document.getElementById("fechaActividad").className.includes("hidden") && (event.target.id === "fechaActividad") ){
        document.getElementById("fechaActividad").className = document.getElementById("fechaActividad").className.replaceAll(" hidden", "") + " hidden"
    }
  }; 

  function abrirFormularioFechas(){
      document.getElementById("fechaActividad").className = document.getElementById("fechaActividad").className.replaceAll("hidden","")    
  }

  function filtrarDatos(){

    var cadenaFiltrado = document.getElementById("textoBuscadorActividad").value.toLowerCase()
    var objLisFiltrado = document.getElementById("listadoResultados").querySelectorAll("li")
    var valorDatoTemp = ""

    //Primero gestiono la visibilidad de las opciones
    for(var x=0; x < objLisFiltrado.length; x++){        
      valorDatoTemp = document.getElementById(objLisFiltrado[x].id).getAttribute('searchtext').toLowerCase()

      if(valorDatoTemp.includes(cadenaFiltrado)){
        document.getElementById(objLisFiltrado[x].id).className = document.getElementById(objLisFiltrado[x].id).className.replaceAll(" hidden", "")
      }
      else{
        document.getElementById(objLisFiltrado[x].id).className = document.getElementById(objLisFiltrado[x].id).className.replaceAll(" hidden", "") + " hidden"
      }        
    }

    //Ahora gestiono la visualización de las cajas en función de si tiene resultados visibles o no      

    var objDetails = document.getElementById("listadoResultados").querySelectorAll("details")
    var idGrupoTemp = ""
    var objLisGrupoTemp = ""
    var contadorGeneralElementosVisiblesGrupoTemp = 0
    var contadorElementosVisiblesGrupoTemp = 0

    for(x=0; x < objDetails.length; x++){        

      idGrupoTemp = objDetails[x].id
      objLisGrupoTemp = document.getElementById(idGrupoTemp).querySelectorAll("li")                
      contadorElementosVisiblesGrupoTemp = 0

      //document.getElementById("botonSeleccionarTodosGrupo"+idGrupoTemp).className = document.getElementById("botonSeleccionarTodosGrupo"+idGrupoTemp).className.replaceAll(" hidden", "") + " hidden"

      for(var y=0; y < objLisGrupoTemp.length; y++){             
        if(!document.getElementById(objLisGrupoTemp[y].id).className.includes(" hidden")){
          contadorElementosVisiblesGrupoTemp = contadorElementosVisiblesGrupoTemp + 1
          contadorGeneralElementosVisiblesGrupoTemp = contadorGeneralElementosVisiblesGrupoTemp + 1
        }          
      }
      
      if( contadorElementosVisiblesGrupoTemp === 0){
        document.getElementById(idGrupoTemp).className = document.getElementById(idGrupoTemp).className.replaceAll(" hidden", "") + " hidden"
      }
      else{
        document.getElementById(idGrupoTemp).className = document.getElementById(idGrupoTemp).className.replaceAll(" hidden", "")
      }

      document.getElementById(objDetails[x].id).setAttribute('open','open')       

    } 

    if(cadenaFiltrado === ""){resetearBusquedaEventos()}

    if( (objDetails.length > 0) && (contadorGeneralElementosVisiblesGrupoTemp === 0) ){
      document.getElementById("divSinResultadosBusqueda").className = document.getElementById("divSinResultadosBusqueda").className.replaceAll(" hidden", "")
    }
    else{
      document.getElementById("divSinResultadosBusqueda").className = document.getElementById("divSinResultadosBusqueda").className.replaceAll(" hidden", "") + " hidden"
    }
    

  }

  function resetearBusquedaEventos(){

    document.getElementById("textoBuscadorActividad").value = ""
    document.getElementById("divSinResultadosBusqueda").className = document.getElementById("divSinResultadosBusqueda").className.replaceAll(" hidden", "") + " hidden"

    var objDetails = document.getElementById("listadoResultados").querySelectorAll("details")    
    var idGrupoTemp = ""
    var objLisGrupoTemp = ""    
    var numeroElementosSeleccionadosTemp = 0

    for(var x=0; x < objDetails.length; x++){        
      
      idGrupoTemp = objDetails[x].id
      objLisGrupoTemp = document.getElementById(idGrupoTemp).querySelectorAll("li")                
      
      if(x === 0){
        document.getElementById(objDetails[x].id).setAttribute('open','open')       
      }
      else{
        document.getElementById(objDetails[x].id).removeAttribute('open')       
      }
            
      numeroElementosSeleccionadosTemp = 0

      for(var y=0; y < objLisGrupoTemp.length; y++){             
        document.getElementById(objLisGrupoTemp[y].id).className = document.getElementById(objLisGrupoTemp[y].id).className.replaceAll(" hidden", "")        
      }
      
      document.getElementById(idGrupoTemp).className = document.getElementById(idGrupoTemp).className.replaceAll(" hidden", "")      

    }  

  }

  function cerrarMediaModal(){    
    
    primeraCargaRealizada = false
    document.getElementById("textoBuscadorActividad").value = ""    

    var fechaActual = new Date(); 
    var añoActual = fechaActual.getFullYear();
    var mesActual = (fechaActual.getMonth()+1);
    var diaActual = fechaActual.getDate();

    if (mesActual < 10){ mesActual = "0"+mesActual;	}
    if (diaActual < 10){ diaActual = "0"+diaActual;	}
    
    document.getElementById("fechaDesde").value = añoActual+"-"+mesActual+"-"+diaActual
    document.getElementById("fechaHasta").value = añoActual+"-"+mesActual+"-"+diaActual
    document.getElementById("horaDesde").value = "00:00"
    document.getElementById("horaHasta").value = "23:59"

    setObjListadoActividad([])
    params.operarDetalleLateralPantallaCompleta("cerrar")
  }

  const listQueryActivity = objListadoActividad.map((dia, index) =>

    <React.Fragment key={dia.DATE}>       
      
      { index === 0 ?
      <details id={dashboardCommonJS.formatearAFechaCorta(dia.DATE)} className="accordion" open>
        <summary className="title">
          <figure className="avatar size-l pink"><span className="material-icon">today</span></figure>            
          <span className="size-l">{dashboardCommonJS.formatearAFechaCorta(dia.DATE)}</span>
        </summary>          
      
        <InstallationActivityDay objActividadDia={dia.DATA} dia={dia.DATE} seleccionarOpcionMenu={params.seleccionarOpcionMenu}/>
        
      </details>      
      : 
      <details id={dashboardCommonJS.formatearAFechaCorta(dia.DATE)} className="accordion">
        <summary className="title">
          <figure className="avatar size-l pink"><span className="material-icon">today</span></figure>            
          <span className="size-l">{dashboardCommonJS.formatearAFechaCorta(dia.DATE)}</span>
        </summary>          
      
        <InstallationActivityDay objActividadDia={dia.DATA} dia={dia.DATE} seleccionarOpcionMenu={params.seleccionarOpcionMenu}/>
        
      </details>      
      }

    </React.Fragment>        

  ); 

  return (        
    <div className="modal-content full-width">
      <button className="link close" onClick={() => cerrarMediaModal()}><span className="material-icon">highlight_off</span></button>
      <div className="page wrapper fill">      

        <section id="intallationActivity" className="wrapper vertical gap-06">

          <div id="botoneraPrincipal" className="content-wrapper" >

            <div className="horizontal space-between">
              <h1 className="headline-02">Actividad</h1>              
              
              <div className="horizontal gap-02">                
                <button className="button tertiary size-s" onClick={ () => abrirFormularioFechas()}><span className="material-icon">event</span>Modificar fecha</button>
              </div>
            </div>

            <div className="vertical">    
              <fieldset id="fieldsetTextoBuscadorActividad" className="search automatic">
                <input type="search" id="textoBuscadorActividad" spellCheck="false" autoComplete="off" placeholder="Buscar evento..." onKeyUp={() => filtrarDatos()}/>
                <span className="material-icon icon-wrapper" onClick={() => resetearBusquedaEventos()}></span>
              </fieldset>
            </div>

          </div>

          <div>

              <div id="listadoResultados" className="accordion-wrapper">
              
                {objListadoActividad.length > 0 ?
                  listQueryActivity               
                : 
                  <div id="divSinResultadosActividad" className="message medium empty">
                    <picture>
                      <source srcSet={imgNoResultsDark} media="(prefers-color-scheme: dark)"/>
                      <img src={imgNoResultsDark} alt=" "/>
                    </picture>
                    <h1 className="title">No hay eventos de actividad en tu instalación</h1>
                    <p>Aquí se muestra la actividad de tus dispositivos y reglas de comportamiento.</p>
                  </div>
                }

                <div id="divSinResultadosBusqueda" className="message medium empty hidden">
                  <picture>
                    <source srcSet={imgNoResultsDark} media="(prefers-color-scheme: dark)"/>
                    <img src={imgNoResultsDark} alt=" "/>
                  </picture>
                  <h1 className="title">No existen resultados para esta búsqueda</h1>                  
                </div>
                
              </div>

            <div id="loaderActividad" className="loader hidden">
              <progress aria-label="" style={{display: 'block', position: 'relative', margin: 'auto'}}></progress>          
            </div>

          </div>
        </section>
      
        <aside id="fechaActividad" className="modal lateral-detail hidden" onMouseDown={gestionarVisibilidadFechasActividad}>

          <div className="modal-content">

            <button className="link close" onClick={() => document.getElementById("fechaActividad").className = document.getElementById("fechaActividad").className.replaceAll(" hidden", "") + " hidden" }><span className="material-icon">highlight_off</span></button>
            <div className="page">
                
                <header>
                  <h1 className="headline-02 fill">Rango de búsqueda</h1>
                </header>

                <ActivitySearchForm objListadoActividad={objListadoActividad} cargarDatosActividadInstalacion={cargarDatosActividadInstalacion}/>                     
                
            </div>
          </div>

        </aside>

      </div>
    </div>
  )
}

export default InstallationActivity